import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import { CognitoUser } from "amazon-cognito-identity-js";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import UserPool from "../UserPool";

const Header = ({ setUser, email, username, nickname }) => {
  let history = useHistory();
  const [isHovering, setIsHovering] = useState(false);

  const getInitials = (name) => {
    if (!name) return "";
    // Remove domínio do email se existir
    const nameWithoutDomain = name.split("@")[0];
    // Divide por espaço ou ponto
    const words = nameWithoutDomain.split(/[\s.]+/).filter((word) => word.length > 0);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return words
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  const signOut = () => {
    const userCognito = new CognitoUser({
      Username: email,
      Pool: UserPool,
    });

    userCognito.signOut();
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    history.push("/");
  };

  const handleReload = () => {
    if (window.location.href === '/') return window.location.reload();
    else return window.location.href = '/'
  }

  return (
    <Container>
      <LeftSection>
        <HomeButton onClick={handleReload}>
          <HomeIconWrapper>
            <HomeIcon style={{ fontSize: '28px' }} />
          </HomeIconWrapper>
        </HomeButton>
        <BrandLogo src="/image/e1_logo.png" alt="Seidor Integration Hub" />
      </LeftSection>

      <RightSection>
        <UserBadge>
          <UserName>{getInitials(email)}</UserName>
        </UserBadge>
        <LogoutButton
          onClick={signOut}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <ExitToAppIcon style={{ fontSize: '20px' }} />
          {isHovering && <LogoutText>Sair</LogoutText>}
        </LogoutButton>
      </RightSection>
    </Container>
  );
};

export default Header;

// Animações
const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

const Container = styled.div`
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-image-slice: 1;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
  padding: 0 24px;
  font-family: 'Mulish', sans-serif;
  position: sticky;
  top: 0;
  z-index: 100;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 16px;
    height: 60px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  animation: ${slideIn} 0.5s ease;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const HomeButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(102, 126, 234, 0.05);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(102, 126, 234, 0.15);
    transform: scale(1.05);

    svg {
      animation: ${pulse} 0.6s ease;
    }
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
  }
`;

const HomeIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  transition: all 0.3s ease;
`;

const HomeText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  transition: color 0.3s ease;

  ${HomeButton}:hover & {
    color: #667eea;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const BrandLogo = styled.img`
  height: 45px;
  width: auto;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    height: 40px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  animation: ${slideIn} 0.5s ease 0.1s both;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const UserBadge = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 18px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 20px;
  border: 2px solid #e8ecf1;
  transition: all 0.3s ease;

  &:hover {
    border-color: #667eea;
    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
  }

  @media (max-width: 768px) {
    padding: 6px 14px;
  }
`;

const UserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Mulish', sans-serif;
  font-weight: 600;

  &:hover {
    background: #e74c3c;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`;

const LogoutText = styled.span`
  font-size: 14px;
  animation: ${slideIn} 0.3s ease;

  @media (max-width: 768px) {
    display: none;
  }
`;
